<template>
  <el-form
    id="task-form"
    ref="form"
    :rules="rules"
    :model="ruleForm"
    label-width="95px"
    size="mini"
  >
    <el-form-item label="任务名" prop="name">
      <el-input
        :disabled="taskType !== `build`"
        v-model="ruleForm.name"
      ></el-input>
    </el-form-item>
    <el-form-item label="所属组" prop="ownerId">
      <el-select
        :disabled="disabled || !!routerOwnerId"
        v-model="ruleForm.ownerId"
        @change="groupChange"
      >
        <el-option
          v-for="item in userGroup"
          :key="item.groupName"
          :label="item.groupName"
          :value="item.groupId"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="流程描述" prop="desc">
      <el-input
        :disabled="disabled"
        type="textarea"
        :rows="3"
        v-model="ruleForm.desc"
        placeholder="请输入文字进行描述"
      ></el-input>
    </el-form-item>
    <el-form-item label="绑定节点">
      <el-col :span="3">
        <el-switch :disabled="disabled" v-model="ruleForm.radio" />
      </el-col>
      <el-col :span="20" :offset="1">
        <el-input
          :disabled="!ruleForm.radio || disabled"
          v-model="ruleForm.node"
          placeholder=""
        ></el-input>
      </el-col>
    </el-form-item>
    <el-form-item label="删除保护" prop="delProtection">
      <el-switch :disabled="disabled" v-model="ruleForm.delProtection" />
    </el-form-item>

    <el-form-item label="所属应用" prop="appId">
      <el-select :disabled="disabled" v-model="ruleForm.appId" clearable>
        <el-option
          v-for="(item, index) in appOptions"
          :key="index"
          :label="item.name"
          :value="item.appId"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="并发控制" prop="concurrentOption">
      <el-select :disabled="disabled" v-model="ruleForm.concurrentOption">
        <el-option label="skip" value="skip"></el-option>
        <el-option label="pipeline" value="pipeline"></el-option>
        <el-option label="ignore" value="ignore"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "task-form",
  props: {
    taskType: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    task: {
      type: Object
    },
    routerOwnerId: {
      type: String,
      default: ""
    }
  },
  data() {
    const validateName = (rule, value, callback) => {
      let reg = /[^A-z0-9_]/g;
      if (!value) {
        callback(new Error("请输入流程名称"));
      } else if (value.length > 32) {
        callback(new Error("流程名称不能超过32个字符"));
      } else {
        if (reg.test(value)) {
          callback(new Error("流程名称仅包含 A-Za-z0-9_"));
        } else {
          callback();
        }
      }
    };
    return {
      ruleForm: {
        name: "",
        ownerId: null,
        desc: "",
        radio: false,
        node: "",
        delProtection: false,
        appId: "",
        concurrentOption: "skip"
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入流程名称",
            trigger: "blur"
          },
          {
            validator: validateName,
            trigger: "change"
          }
        ],
        ownerId: [
          {
            required: true,
            message: "请选择所属者",
            trigger: "change"
          }
        ],
        desc: [
          {
            required: true,
            message: "请输入流程描述",
            trigger: "change"
          },
          {
            min: 30,
            message: "流程描述应大于30个字符",
            trigger: "change"
          }
        ]
      },
      appOptions: []
    };
  },
  computed: {
    userGroup() {
      return this.$store.state.userGroup;
    }
  },
  watch: {
    task: {
      immediate: true,
      handler(v) {
        if (v) {
          this.ruleForm = JSON.parse(JSON.stringify(v));
        }
      }
    },
    routerOwnerId: {
      immediate: true,
      handler(v) {
        if (v) {
          this.$set(this.ruleForm, "ownerId", parseInt(this.routerOwnerId));
          this.groupChange(parseInt(this.routerOwnerId));
        }
      }
    },
    userGroup: {
      immediate: true,
      handler(v) {
        if (v.length && !this.routerOwnerId) {
          this.ruleForm.ownerId = v[0].groupId;
          this.groupChange(v[0].groupId);
        }
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.get("/gavial/v1/app/names").then(res => {
        this.appOptions = res.data.data;
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve(this.ruleForm);
          } else {
            this.$message({
              type: "error",
              message: "基础设施参数填写错误"
            });
            reject("first");
          }
        });
      });
    },
    groupChange(v) {
      this.$emit("groupChange", v);
    }
  }
};
</script>

<style lang="scss" scoped>
#task-form {
  padding: 15px 10px;
}
</style>
